"use client"

import {themeData} from "./themedata";
import {transparentize} from "@chakra-ui/theme-tools";
import {Roboto} from 'next/font/google';
import {createTheme} from "@mui/material";

const roboto = Roboto({
    weight: ['300', '400', '500', '700'],
    subsets: ['latin'],
    display: 'swap',
});
// @ts-ignore
export function muiTheme(colorMode: string) {
    return createTheme({
        typography: {
            fontFamily: roboto.style.fontFamily,
        },
        palette: {
            mode: 'dark',

        },
        colorSchemes: {
            dark: {
                palette: {
                    text: {
                        primary: themeData.schemes.dark.primary,
                        secondary: themeData.schemes.dark.secondaryFixedDim,
                    },
                    primary: {
                        main: themeData.schemes.dark.primary
                    },
                    info: {
                        main: themeData.schemes.dark.onSurface
                    },
                    background: {
                        paper: themeData.schemes.dark.surface,
                        default: themeData.schemes.dark.surface
                    }
                }
            },
            light: {
                palette: {
                    text: {
                        primary: themeData.schemes.light.primary,
                        secondary: themeData.schemes.light.secondaryFixedDim,
                    },
                    primary: {
                        main: themeData.schemes.light.primary
                    },
                    info: {
                        main: themeData.schemes.light.onSurface
                    },
                    background: {
                        paper: themeData.schemes.light.surface,
                        default: themeData.schemes.light.surface
                    }
                }
            }
        },
        components: {
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        borderWidth: '1px',
                        borderColor: transparentize(colorMode === 'dark' ? themeData.schemes.dark.onSurfaceVariant : themeData.schemes.light.onSurfaceVariant, 0.3),
                        '&.Mui-focused': {
                            borderColor: colorMode === 'dark' ? themeData.schemes.dark.primary : themeData.schemes.light.primary,
                            borderWidth: '1px'
                        },
                    } as any,
                    input: {
                        color: colorMode === 'dark' ? themeData.schemes.dark.onSurface : themeData.schemes.light.onSurface,
                    }
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: colorMode === 'dark' ? themeData.schemes.dark.onSurfaceVariant : themeData.schemes.light.onSurfaceVariant
                    },
                },
            },
            //@ts-ignore
            "MuiPickersPopper": {
                styleOverrides: {
                    root: {
                        '& .MuiPaper-root': {
                            backgroundColor: colorMode === 'dark' ? themeData.schemes.dark.surfaceContainer : themeData.schemes.light.surfaceContainer,
                        },
                    },
                },
            },
        },
    });
}